import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { DataGridSetting, Breadcrumb } from "../../../../components";
import { Button } from "../../../../shared";
import { useProductCategory } from "../../../../hooks/query";

import { columnDef } from "./column-def";
import { StatusCellRenderer, Info } from "./GridFrameworks";

import type { IProductCategory } from "../../../../interfaces";

export default function List() {
    const { useList } = useProductCategory();
    const { data, isLoading, isError, error } = useList();

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load product categories"}
                </Box>
            </Box>
        );
    }

    const categories = (data as IProductCategory[]) || [];

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={categories}
                    columnDefs={columnDef.map((col) => {
                        if (col.cellRenderer === "StatusCellRenderer") {
                            return { ...col, cellRenderer: StatusCellRenderer };
                        }
                        if (col.cellRenderer === "Info") {
                            return { ...col, cellRenderer: Info };
                        }
                        return col;
                    })}
                    quickControlStartDecorator={<CreateCategoryButton />}
                />
            </Box>
        </Box>
    );
}

function CreateCategoryButton() {
    return (
        <Box display="flex" alignItems={"center"} ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/admin/product-category/create"
                startDecorator={<Plus size={18} />}
            >
                Create Category
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
